module.exports = __webpack_public_path__ + "img/9.dda2d517.png";